export default {
  "title": {
    "tasks_traceability": "Deviation’s traceability",
    "notifications_traceability": "Notification traceability"
  },
  "labels": {
    "totalTasks": "Number of tasks"
  },
  "table": {
    "occurrenceDate": "Occurrence",
    "createdDate": "Creation",
    "closedDate": "Closure",
    "type": "Type",
    "subtype": "Subtype",
    "person": "Worker",
    "vehicle": "Vehicle",
    "accountable": "Responsible",
    "manager": "Managed by",
    "state": "State",
    "noData": "There is no more data"
  },
  "tooltip": {
    "occurrenceDate": "It corresponds to the exact date and time in which the deviation occurred.",
    "createdDate": "It corresponds to the date in which the deviation was created in the Gauss Control system.",
    "closedDate": "It corresponds to the date in which the deviation was managed.",
    "type": "It corresponds to the type of deviation to which it applies to. For example, legal compliance, distraction, fatigue event, among others.",
    "subtype": "It corresponds to the subtype to which the deviation applies to. For example, if it is legal compliance, its subtypes are: daily resting was breached, overtiming day, among others.",
    "person": "It corresponds to the worker who breached or a generated deviation.",
    "vehicle": "It corresponds to the license plate of the used vehicle. It only applies for deviations which involve driving.",
    "accountable": "It corresponds to the person or persons responsible of managing the deviation.",
    "manager": "It corresponds to the person who managed the deviation.",
    "desvHelp1": "It corresponds to the state of the deviation management.",
    "desvCat1Label": "Open:",
    "desvCat2Label": "Closed on time:",
    "desvCat3Label": "Expired closed:",
    "desvCat4Label": "Expired:",
    "desvCat5Label": "Cancelled:",
    "desvCat6Label": "Notifications:",
    "desvCat1LabelDesc": "deviations that still have not been managed but are within deadline.",
    "desvCat2LabelDesc": "deviations that have been managed within deadline.",
    "desvCat3LabelDesc": "deviations that have been managed out of the established deadline.",
    "desvCat4LabelDesc": "deviations that have not been managed and its deadline expired.",
    "desvCat5LabelDesc": "deviations to which corresponded false-positive events so were cancelled from the system by the person in charge.",
    "desvCat6LabelDesc": "deviations in which the events do not require managing."
  },
  "filters": {
    "type": "Type",
    "state": "State",
    "person": "Employee",
    "vehicle": "Vehicle",
    "accountable": "Responsible",
    "manager": "Managed by",
    "geoZone": "Geozone",
    "all": "All",
    "stateOptions": {
      "": "All",
      "Abierta": "Open",
      "Cerrada": "Closed",
      "Cerrada vencida": "Expired closed",
      "Vencida": "Expired"
    },
    "annulTasks": "Cancel tasks",
    "show": "Display",
    "subtype": "Subtype",
    "workingShiftGroup": "Shift group"
  },
  "states": {
    "CLOSED": "Closed on time",
    "OPEN": "Open",
    "OVERDUE": "Expired",
    "CLOSEDOVERDUE": "Expired closed",
    "ANNULLED": "Cancelled",
    "NOTIFICATION": "Notification",
    "PENDINGRECLASIFICATION": "Pending reclassification"
  },
  "taskform": {
    "description": "Description",
    "taskCreationDate": "Date creation",
    "download": "Download",
    "downloading": "Downloading",
    "downloadErrorMediaTitle": "Failed to download",
    "downloadErrorMediaDescription": "An error occurred while downloading the file, please try again.",
    "fileNotUploaded": "File wasn’t uploaded",
    "save": "Close task",
    "closed": "Closed task",
    "taskInformation": "Task information",
    "taskManagement": "Task management",
    "dueDate": "Expiration date",
    "eventDate": "Event date",
    "taskCloseDate": "Closure date",
    "taskClosed": "Closed task",
    "next": "Next",
    "back": "Previous",
    "plate": "Plate",
    "driver": "Driver",
    "BREATHALYSER": "Breathalyser",
    "PVTTEST": "PVT",
    "FORM": "Survey",
    "detail": "Detail",
    "loadingOptions": "Loading options.",
    "loadingOptionsError": "Loading options error, try loading the deviation again.",
    "loadingMedia": "Loading file.",
    "loadingMediaError": "Loading file error, load the deviation again.",
    "actions": {
      "Reclassify": "Re-classify task",
      "Annul": "Cancel task",
      "Close": "Finish task",
      "Save": "Save task draft"
    },
    "actionsResults": {
      "Reclassify": "Re-classified deviation",
      "Annul": "Cancelled deviation",
      "Close": "Closed deviation",
      "Save": "Saved deviation"
    },
    "invalid": "You must complete this field to close the deviation.",
    "showDescription": "ver descripción",
    "hideDescription": "ocultar descripción",
    "goBack": "Back",
    "withoutDeviationInformation": "No information related to the deviation was found."
  },
  "excel": {
    "downloadExcel": "Download data as an Excel file",
    "downloadSummaryExcel": "Download summarized data",
    "downloadNoProcessExcel": "Download unprocessed data",
    "downloadFileNameSummary": "data_manager_task_summary",
    "downloadFileNameNoProcess": "data_manager_task_no_process",
    "downloadErrorDateRangeTitle": "Download date range not allowed",
    "downloadErrorDateRangeDescription": "You have exceeded the allowed download date range (3 months or less). To request a report covering a period greater than 3 months, please contact the Gauss Control help desk.",
    "downloadingTitle": "Downloading report",
    "downloadingPleaseWait": "Processing your download, this operation could take several minutes..."
  },
  "feedback": {
    "maxToAnnulReached": "The maximum number of deviations selected to be cancelled has been exceeded.",
    "nothingSelectedToAnnul": "You must select at least one deviation to cancel.",
    "annulSuccess": "Deviations successfully cancelled",
    "annulError": "An error has occurred when trying to cancel a deviation. Please, try again.",
    "editSuccess": "Deviation has been successfully modified",
    "editError": "An error has occurred when trying to modify a deviation. Please, try again."
  },
  "annulConfirm": {
    "confirmButton": "Yes",
    "cancelButton": "No",
    "question": "Are you sure you want to cancel these deviations?",
    "warning": "When a deviation is cancelled it will no longer be able to apply the corresponding management.",
    "questionSingle": "Are you sure you want to cancel this deviation?",
    "warningSingle": "When proceeding with this action the deviation will be inactive in the system and cannot be activated again to be managed."
  },
  "topCharts": {
    "tasksByState": "Tasks distribution by state",
    "totalTasks": "Total",
    "manageTasks": "Management tasks",
    "notifications": "Notifications"
  },
  "driverErrorAlert": {
    "confirmButton": "¡Got it!",
    "title": "According to the system this deviation belongs to a different employee",
    "line1a": "It has been identified that this deviation belongs to this employee",
    "line1b": ", which does not correspond to the employee selection done.",
    "line2": "The Gauss Control system has previously assigned the employee to which the deviation belongs to. Thanks to the obtained information from different sources, it is possible to identify and automatically assign the corresponding people.",
    "line3": "Update the platform to refresh the information."
  },
  "tab": {
    "not_tabs_assigned": "No tabs assigned",
    "tasks": "Deviations",
    "notifications": "Notifications",
    "detail": "Detail"
  },
  "redirectDetail": {
    "sessionExpiredTitle": "Session expired",
    "sessionExpiredMessage": "Open the link we provided again to log in and access your account."
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/task_manager/taskManager.js